import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMijnBedrijfsruimte = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M9 16h22v16H9zm2-8h18v5H11z"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="M13 24h5v8h-5zm9 0h5v5h-5zm10-8c0 1.66-1.34 3-3 3s-3-1.34-3-3c0 1.66-1.34 3-3 3s-3-1.34-3-3c0 1.66-1.34 3-3 3s-3-1.34-3-3c0 1.66-1.34 3-3 3s-3-1.34-3-3v-3h24z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M31 16.5h-1v-6H16v-1h15zM13 20.5c-1.93 0-3.5-1.57-3.5-3.5h1a2.5 2.5 0 0 0 5 0h1c0 1.93-1.57 3.5-3.5 3.5"
    />
    <path
      fill="#00215B"
      d="M19 20.5c-1.93 0-3.5-1.57-3.5-3.5h1a2.5 2.5 0 0 0 5 0h1c0 1.93-1.57 3.5-3.5 3.5"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMijnBedrijfsruimte);

export default ForwardRef;
